module.exports = __webpack_public_path__ + "img/provider4.84d31bb8.jpg";